module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-flow-04-0adc9d7fc0013755e60e4bc1438095ad.png";